import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import { fb } from '@/components/common.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cachalogTitleJp: 'カチャログ',
    cachalogTitleEn: 'CACHALOG',
    cachalogUrl: 'https://cachalog.jp/',
    backgroundColor: {
      'mypage': '#F0EEE7',
      'receipt': '#F0EEE7'
    },
    notFound: false,
    asyncQueue: [],
    addPageQueue: [],
    anonymous: false,
    signInAnonymous: false,
    providerData: {},
    user: {images: []},
    users: {},
    members: [],
    page: {
      items: [],
      images: [{}, {}],
      dates: []
    },
    tempPage: {
      // title: '',
      // description: '',
      items: [],
      images: [{}, {}],
      links: [{}],
      dates: []
    },
    iniPage: {
      created: fb.firestore.FieldValue.serverTimestamp(),
      dates: [],
      images: [{id: '1'}, {id: '2'}],
      items: [],
      images_counter: 2,
      items_counter: 0,
      links: [{}],
      publish: false,
      deleted: null
    },
    pageImages: [
      {id: 'top-image', class: [{'is-3by1': true}]},
      {id: 'top-circle', class: [{'is-128x128': true}, {'is-rounded': true}]}
    ],
    wishlist: {
      items: [],
      histories: []
    },
    wishlistOperationCounter: 0,
    snsIconClasses: {
      'twitter.com': {'twitter': true},
      'google.com': {'google': true},
      'facebook.com': {'facebook': true}
    },
    imagePosition: null,
    imageUploadProgress: 0,
    imageSourceQueue: [],
    historiesQueue: [],
    errorQueue: [],
    mypageCurrentList: 1,
    order: {},
    // orders: {},
    sales: {},
    receipts: {},
    cache: {
      images: {},
      pages: {},
      wishlists: {}
    },
    routes: [],
    pageMainComponent: 'page',
    disablePageCreate: 'true',
    callbacks: []
  },
  /*
  *
  * GETTERS
  *
  */
  getters: {
    isMember: state => {
      if (state.page.members) {
        return state.page.members.some(
          member => 'users/' + state.user.uid === member.users_ref.path
        )
      }
      return false
    },
    isSignIn: state => {
      return state.user.uid && !state.anonymous
    },
    totalQuantity: state => {
      return state.wishlist.items.reduce((a, b) => {
        b.quantity -= 0
        return a + b.quantity
      }, 0)
    },
    pageStatus: state => {
      return state.page.publish
        ? 'このショップは公開中です。'
        : 'このショップは非公開です。'
    }
  },
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js